import {Controller} from '@stubhub/react-store-provider';

import {eventCountryCodeSelector, eventCurrencySelector} from '../../../../store/event/selectors';
import {
  showBrokerInfoDSASelector,
  showBrokerInfoSelector,
  showImportantInfoModalSelector,
} from '../../../../store/gsConfig/FF/selectors';

import {eventDataSelector, listingsDataSelector, zoneColorsSelector} from './selectors';

const controller = new Controller({
  namespace: 'ticketList',
  mapStateToProps(state = /* istanbul ignore next */ {}) {
    const localState = this.getLocalState(state);

    return {
      ...eventDataSelector(state),
      ...listingsDataSelector(state),
      showBrokerInfo: showBrokerInfoSelector(state) || false,
      showBrokerInfoDSA: showBrokerInfoDSASelector(state) || false,
      screenSize: (state.viewport && state.viewport.screenSize) || 'medium',
      acknowledgedMsg: localState.acknowledgedMsg,
      hoveredListingSid: localState.hoveredListingSid || null,
      showImportantInfoModal: showImportantInfoModalSelector(state) || false,
      zoneColors: zoneColorsSelector(state),
      eventCountry: eventCountryCodeSelector(state),
      eventCurrency: eventCurrencySelector(state),
    };
  },
  actionCreators: {
    setPage,
    updateHoveredSectionId,
    updateHoveredZoneId,
  },
  reducers: ['EVENT:LISTING_NEW_PAGE', 'EVENT:LISTING_HOVERED_SID', 'EVENT:LISTING_HOVERED_ZID'],
});

function setPage(page) {
  return (dispatch) => {
    dispatch({type: 'EVENT:LISTING_NEW_PAGE', page});
  };
}

function updateHoveredSectionId(sectionId) {
  if (sectionId) {
    return (dispatch) => {
      dispatch({type: 'EVENT:LISTING_HOVERED_SID', hoveredListingSid: sectionId});
    };
  }

  return (dispatch) => {
    dispatch({type: 'EVENT:LISTING_HOVERED_SID', hoveredListingSid: null});
  };
}

function updateHoveredZoneId(zoneId) {
  if (zoneId) {
    return (dispatch) => {
      dispatch({type: 'EVENT:LISTING_HOVERED_ZID', hoveredListingZid: zoneId});
    };
  }

  return (dispatch) => {
    dispatch({type: 'EVENT:LISTING_HOVERED_ZID', hoveredListingZid: null});
  };
}

export default controller;
